export const BASE_10 = 10;
export const CRYPTO_CONNECT_INVALID = 'CRYPTO_CONNECT_INVALID';
export const EMAIL_INVALID = 'EMAIL_INVALID';
export const EMAIL_OR_USER_DOES_NOT_EXIST = 'EMAIL_OR_USER_DOES_NOT_EXIST';
export const INCORRECT_PASSWORD_PROVIDED = 'INCORRECT_PASSWORD_PROVIDED';
export const LOGIN_INVALID = 'LOGIN_INVALID';
export const PARROT_TOKEN_CLAIM_INVALID = 'PARROT_TOKEN_CLAIM_INVALID';
export const PASSWORD_INVALID = 'PASSWORD_INVALID';
export const PURCHASE_CONNECTED_WALLET_REQUIRED = 'PURCHASE_CONNECTED_WALLET_REQUIRED';
export const PURCHASE_EVENT_CLOSED = 'PURCHASE_TICKET_EVENT_CLOSED';
export const PURCHASE_EVENT_DOES_NOT_EXIST = 'PURCHASE_TICKET_EVENT_DOES_NOT_EXIST';
export const PURCHASE_EVENT_FULL = 'PURCHASE_EVENT_FULL';
export const PURCHASE_INSUFFICIENT_FUNDS = 'PURCHASE_INSUFFICIENT_FUNDS';
export const PURCHASE_INVALID_OUTCOME = 'PURCHASE_TICKET_INVALID_OUTCOME';
export const PURCHASE_LOCATION_NOT_PROVIDED = 'PURCHASE_LOCATION_NOT_PROVIDED';
export const PURCHASE_NFT_REQUIRED = 'PURCHASE_NFT_REQUIRED';
export const REGISTER_EMAIL_EXISTS = 'REGISTER_EMAIL_EXISTS';
export const RESET_PASSWORD_INVALID_KEY = 'RESET_PASSWORD_INVALID_KEY';
export const RESET_PASSWORD_INVALID_PASSWORD = 'RESET_PASSWORD_INVALID_PASSWORD';
export const STATE_PROVINCE_INVALID = 'STATE_PROVINCE_INVALID';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const USERNAME_CHANGE_TIMEOUT = 'USERNAME_CHANGE_TIMEOUT';
export const USERNAME_NOT_AVAILABLE = 'USERNAME_NOT_AVAILABLE';
export const USERNAME_INVALID = 'USERNAME_INVALID';
export const HTTP_ERROR_BAD_REQUEST = 'HTTP_ERROR_BAD_REQUEST';
export const HTTP_ERROR_FORBIDDEN = 'HTTP_ERROR_FORBIDDEN';
export const HTTP_ERROR_NOT_AUTHORIZED = 'HTTP_ERROR_NOT_AUTHORIZED';
export const HTTP_ERROR_NOT_FOUND = 'HTTP_ERROR_NOT_FOUND';
export const HTTP_ERROR_SERVER_ERROR = 'HTTP_ERROR_SERVER_ERROR';
export const HTTP_ERROR_SERVICE_UNAVAILABLE = 'HTTP_ERROR_SERVICE_UNAVAILABLE';
export const EVENT_STATUS_CANCELLED = 'x';
export const EVENT_STATUS_CLOSED = 'c';
export const EVENT_STATUS_FINALIZED = 'f';
export const EVENT_STATUS_NEW = 'n';
export const EVENT_STATUS_OPEN = 'o';
export const EVENT_GAME_TYPE_FANTASY_STATS = 'fantasy_stats';
export const EVENT_GAME_TYPE_PROP_STAKE = 'prop_stake';
